import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ApiStore {
  userDataCall: boolean;
  selectedStyleCall: boolean;
  reportDataCall: boolean;
  initialIndicatorsCall: boolean;
  valuationDataCall: boolean;
  valuationIndicatorsCall: boolean;
  histogramIndicatorsCall: boolean;
  similarComparablesCall: boolean;
  financialIndicatorsCall: boolean;
  offerDemandIndicatorsCall: boolean;
  zonePopulationIndicatorsCall: boolean;
  zoneIndicatorsCall: boolean;
  readyToSendErrorReport: boolean;
  errorReportSent: boolean;
  markApiCallsAsCompleted: (apiNumber: number) => void;
  setErrorReportSent: (errorReportSent: boolean) => void;
}

export const useApiStore = create<ApiStore>()(
  devtools((set, get) => ({
    userDataCall: false,
    selectedStyleCall: false,
    reportDataCall: false,
    initialIndicatorsCall: false,
    valuationDataCall: false,
    valuationIndicatorsCall: false,
    histogramIndicatorsCall: false,
    similarComparablesCall: false,
    financialIndicatorsCall: false,
    offerDemandIndicatorsCall: false,
    zonePopulationIndicatorsCall: false,
    zoneIndicatorsCall: false,
    errorReportSent: false,
    readyToSendErrorReport: false,
    setErrorReportSent: (errorReportSent: boolean) => {
      set({ errorReportSent: errorReportSent });
    },
    markApiCallsAsCompleted: (apiNumber: number) => {
      if (apiNumber === 1) set({ userDataCall: true });
      if (apiNumber === 2) set({ selectedStyleCall: true });
      if (apiNumber === 3) set({ reportDataCall: true });
      if (apiNumber === 4) set({ initialIndicatorsCall: true });
      if (apiNumber === 5) set({ valuationDataCall: true });
      if (apiNumber === 6) set({ valuationIndicatorsCall: true });
      if (apiNumber === 7) set({ histogramIndicatorsCall: true });
      if (apiNumber === 8) set({ similarComparablesCall: true });
      if (apiNumber === 9) set({ financialIndicatorsCall: true });
      if (apiNumber === 10) set({ offerDemandIndicatorsCall: true });
      if (apiNumber === 11) set({ zonePopulationIndicatorsCall: true });
      if (apiNumber === 12) set({ zoneIndicatorsCall: true });
      const {
        userDataCall,
        selectedStyleCall,
        reportDataCall,
        valuationDataCall,
        valuationIndicatorsCall,
        histogramIndicatorsCall,
        similarComparablesCall,
        financialIndicatorsCall,
        offerDemandIndicatorsCall,
        zonePopulationIndicatorsCall,
        zoneIndicatorsCall,
      } = get();
      // console.log('userDataCall', userDataCall);
      // console.log('selectedStyleCall', selectedStyleCall);
      // console.log('reportDataCall', reportDataCall);
      // console.log('valuationDataCall', valuationDataCall);
      // console.log('valuationIndicatorsCall', valuationIndicatorsCall);
      // console.log('histogramIndicatorsCall', histogramIndicatorsCall);
      // console.log('similarComparablesCall', similarComparablesCall);
      // console.log('financialIndicatorsCall', financialIndicatorsCall);
      // console.log('offerDemandIndicatorsCall', offerDemandIndicatorsCall);
      // console.log('zonePopulationIndicatorsCall', zonePopulationIndicatorsCall);
      // console.log('zoneIndicatorsCall', zoneIndicatorsCall);
      if (
        userDataCall &&
        selectedStyleCall &&
        reportDataCall &&
        valuationDataCall &&
        valuationIndicatorsCall &&
        histogramIndicatorsCall &&
        financialIndicatorsCall &&
        offerDemandIndicatorsCall &&
        zonePopulationIndicatorsCall &&
        zoneIndicatorsCall &&
        get().errorReportSent === false &&
        get().readyToSendErrorReport === false
      ) {
        set({ readyToSendErrorReport: true });
      }
    },
  }))
);
